export enum CloudFunction {
  authorizeUser = 'authorizeUser',
  fetchFeatureFlagsConfig = 'fetchFeatureFlagsConfig',
  fetchPurchaseUrl = 'fetchPurchaseUrl',
  fetchQuoteById = 'fetchStorageQuoteByQuoteId',
  fetchQuoteWithPartialRequestData = 'fetchQuoteWithPartialRequestData',
  isValidDiscountCode = 'isValidDiscountCode',
  fetchUserReferralLink = 'fetchUserReferralLink',
}
